import Vue from 'vue'
import RootMarketplaceMixin from 'GroomyRoot/mixins/Marketplace.js'

export default Vue.util.mergeOptions(RootMarketplaceMixin, {
    
})